import { Util } from "@phdsoft/common";
import { IStructureElement, RepairCategories, RepairTypes } from "./IStructureEleement";
import { StructuralElement } from "./StructuralElement";
import * as THREE from '@phdsoft/three';
// export interface SurfaceElement extends StructuralElement {

// }

// export class SurfaceElement extends GeometricSurfaceElement implements IStructureElement {
export class SurfaceElement extends StructuralElement implements IStructureElement {
    public VerifyProperties() {
        throw new Error("Method not implemented.");
    }
    Weight?: number;
    Volume?: number;
    OnFrontSide?: boolean;
    StrakeColor?: string;
    RepairCategory?: RepairCategories;
    RepairTypes?: RepairTypes;
    RenewalFactor?: number;


  //#region Degradation

    SubstantialCorrosionThickness?: number
    ExcessiveCorrosionThickness?: number
    AbsoluteDegradation?: number
    RelativeDegradation?: number
    CorrosionRate?: number
    RemainingLife?: number
    EstimatedThickness?: number
    CorrosionRiskIndex?: number

  //#endregion


    // constructor(properties?: any, mesh?: any);
    constructor(mesh?: any, material?: THREE.Material, id?: string) {
        super(mesh, material, id);
        this.Guid = mesh?.userData.Guid;
        this.regionId = mesh?.userData.RegionId ?? mesh?.userData.FrontCompartmentID;
        this.SectionId = mesh?.userData.SectionID;
        this.regionIds = mesh?.userData.RegionIds;
        this.elementTypeName = 'SurfaceElement';
        this.TypeId = mesh?.userData.TypeId;
        this.isRepair = mesh?.userData.IsRepair != undefined && mesh?.userData.IsRepair? true : false;
        // this.isExecuted = mesh?.userData.IsExecuted != undefined && mesh?.userData.IsExecuted? true : false;
        delete mesh?.userData.Guid;
        delete mesh?.userData.RegionId;
        delete mesh?.userData.SectionID;
        delete mesh?.userData.RegionIds;
        delete mesh?.userData.TypeId;
        delete mesh?.userData.Area;
        delete mesh?.userData.BackCompartmentID;
        delete mesh?.userData.Boundaries;
        delete mesh?.userData.Class;
        delete mesh?.userData.CoupledLinearElementIds;
        delete mesh?.userData.FrontCompartmentID;
        delete mesh?.userData.Label;
        delete mesh?.userData.Line;
        delete mesh?.userData.PointsValues;
        delete mesh?.userData.Type;
        delete mesh?.userData.tolerance;
    }

    ComputeMaximumDegradationRate(): number {
        throw new Error("Method not implemented.");
    }
    GetDegradationStatus(): string {
        throw new Error("Method not implemented.");
    }
    GetDegradationColor(): string {
        throw new Error("Method not implemented.");
    }
    ComputeAverageOfPoints(): void {
        throw new Error("Method not implemented.");
    }
    ComputeMinimumRemainingLife(): number {
        throw new Error("Method not implemented.");
    }
    ComputeMaximumRelativeDegradation(): number {
        throw new Error("Method not implemented.");
    }

    public clone(counter:number = 1): SurfaceElement {
        var clone = new SurfaceElement();
        clone.Guid = this.Guid;
        clone.regionId = this.regionId;
        clone.SectionId = this.SectionId;
        clone.regionIds = this.regionIds;
        clone.TypeId = this.TypeId;
        clone.properties = JSON.parse(JSON.stringify(this.properties));
        clone.properties.General.Label = this.properties.General.Label+"_"+counter;
        clone.thickness = this.thickness;
        clone.MaterialType = this.MaterialType;
        clone.MaterialSubType = this.MaterialSubType;
        // clone.SectionId =
        return clone;
    }

    public cloneWithGeometry(geometry:THREE.BufferGeometry, material:THREE.Material, id?:string):SurfaceElement{
        let clone = this.clone();
        clone.Guid = id.replace(/-/g, '') as string;
        clone.properties.Id = id;
        clone.properties.id = id;
        clone.properties.ElementId = id;
        let mesh = new THREE.Mesh(geometry, material);
        mesh.name = id.replace(/-/g, '') as string;
        mesh.visible = true;
        clone.SurfaceDesign = mesh;
        clone.SurfaceDesign.userData.scale = 1;
        clone.SurfaceDesign.geometry.computeBoundingBox();
        clone.SurfaceDesign.geometry.computeBoundingSphere();
        clone.SurfaceDesign.geometry.computeVertexNormals();
        clone.SurfaceDesign.updateMatrixWorld();
        clone.SurfaceDesign.updateMatrix();
        clone.SurfaceDesign.updateWorldMatrix(true, true);
        // clone.SurfaceDesign.upda
        clone.defaultMaterial = material;
        clone.currentMaterial = material;

        return clone;
    }
}
